const hiddenPage = [
  "help",
  "contact",
  "terms-of-service",
  "privacy-policy",
  "specified_commercial_transactions",
  "warranty-policy",
  "return-policy",
];

let countMovePage = 0;
let session = sessionStorage.getItem("countMovePage");
let isHiddenPageFlag = false;
let currentDate = new Date();
let promotedDate = new Date(parseInt(localStorage.getItem("promotedDate")));
promotedDate.setDate(promotedDate.getDate() + 7);

// 地域判定関数
const isInternationalVersion = () => {
  return window.location.pathname.indexOf('/en') === 0 || 
         window.location.pathname.indexOf('/en-bc') === 0 || 
         window.location.href.indexOf('en.moln.com') !== -1;
};

// LINE登録モーダルを表示する関数
const showLineModal = () => {
  const modal = document.getElementById('lineModal');
  if (modal) {
    modal.classList.add('show');
    
    // 閉じるボタンのイベントリスナー（初回のみ）
    if (!modal.hasEventListeners) {
      const closeButton = document.getElementById('closeLineModal');
      const backdrop = modal.querySelector('.LineModal__Backdrop');
      
      if (closeButton) {
        closeButton.addEventListener('click', hideLineModal);
      }
      
      if (backdrop) {
        backdrop.addEventListener('click', hideLineModal);
      }
      
      modal.hasEventListeners = true;
    }
  }
};

// LINE登録モーダルを非表示にする関数
const hideLineModal = () => {
  const modal = document.getElementById('lineModal');
  if (modal) {
    modal.classList.remove('show');
  }
};

const showModal = () => {
  if (Number(session) >= 6) {
    hiddenPage.forEach((page) => {
      if (location.pathname.includes(page)) {
        isHiddenPageFlag = true;
      }
    });
    if (!isHiddenPageFlag) {
      countMovePage = 0;
      // 地域に応じてモーダルを出し分け
      if (isInternationalVersion()) {
        // 海外版：Klaviyoフォームを表示
        // staging
        // window._klOnsite = window._klOnsite || [];
        // window._klOnsite.push(["openForm", "R6anG2"]);

        // production
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'XasYFJ']);
      } else {
        // 日本版：LINE登録モーダルを表示
        showLineModal();
      }

      // モーダルを表示した日時を保存する
      localStorage.setItem("promotedDate", currentDate.getTime());
    } else {
      countMovePage = Number(session) + 1;
    }
  } else if (Number(session) > 0) {
    countMovePage = Number(session) + 1;
  } else {
    countMovePage = 1;
  }
}
if (promotedDate = "Invalid Date" || promotedDate < currentDate) {
  showModal();
}
sessionStorage.setItem("countMovePage", countMovePage);
console.log("session Last:", sessionStorage.getItem("countMovePage"));